import * as React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { parse } from 'url';
import { compose } from 'recompose';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../utils/translateUtils';

const enhance = compose(translate, passApplication);

const ConversionModalView = ({
  baseUrl,
  onClose,
  application: { authorization, settings },
  lng
}) => {
  const appConfig = {
    graphqlGateway: settings.get('graphqlGateway'),
    utcomGateway: {
      rest: {
        url: parse(settings.get('grpcGateway').url)
      }
    }
  };

  return (
    <Parcel
      config={() => import('@unitedtraders/conversion-microfrontend')}
      mountParcel={mountRootParcel}
      locale={lng}
      getTokens={() => authorization.getTokens()}
      appConfig={appConfig}
      basename={baseUrl}
      closeModal={onClose}
      goToInvestment={() => null((window.location.href = '/investments'))}
    />
  );
};

export const ConversionModal = enhance(ConversionModalView);



// WEBPACK FOOTER //
// ./src/components/ConversionModal.jsx